/**
 * `location` → **Settings** (spec M1-B5 §6.2, card P-123).
 *
 * `location`'s `Settings` submenu is captured whole
 * (`editors/location/dialog-settings-0.json`): description, required, validation, restrict
 * editing, restrict view, save as template — no *Customize Location column*.
 * `locationSettingsSchema` is `{hide_footer}` and the type stores no geocoding provider (q336).
 */
import type { LocationSettings } from '@elizmonday/shared';
import { HideSummaryField, SettingsForm, useSettingsDraft } from '../settings-kit';
import type { ColumnSettingsProps } from '../types';

export function LocationSettingsDialog({ settings, onCommit, onCancel }: ColumnSettingsProps<LocationSettings>) {
  const [draft, patch] = useSettingsDraft<LocationSettings>(settings);
  return (
    <SettingsForm
      title="Location column settings"
      testId="location-settings"
      onSave={() => onCommit(draft)}
      onCancel={onCancel}
    >
      <HideSummaryField
        divider={false}
        testId="location-hide-footer"
        checked={draft.hide_footer ?? false}
        onChange={(next) => patch({ hide_footer: next })}
      />
    </SettingsForm>
  );
}
